import backgroundLogin from "../assets/images/background_login.svg";
import "../assets/styles/index.css";

const GuestRouteLayout = ({ children }) => {
  return (
    <div className="guest-container">
      <div className="guest-layout-shell position-relative">
        <img src={backgroundLogin} className="bg_login" alt="" aria-hidden="true" />
        <div className="bg_login_overlay" />
        <div className="guest_content">{children}</div>
      </div>
    </div>
  );
};

export default GuestRouteLayout;
